import { call, put } from "redux-saga/effects";
import _ from "lodash";
import endpoint from "./endpoint";
import { saveAs } from "file-saver";

const currencyFormat = new Intl.NumberFormat("en-US", {
  maximumFractionDigits: 2,
  minimumFractionDigits: 2,
});

export const amountFormat = (amount) => {
  return Number.isNaN(amount) ? "-" : currencyFormat.format(parseFloat(amount));
};

export function exportToFile({ format, res }) {
  //pdf
  if (format === "pdf") {
    const pdfBlob = new Blob([res.data], { type: "application/pdf" });
    saveAs(pdfBlob, "InventorySample.pdf");
  } else if (format === "xlsx") {
    //excel

    const excelBlob = new Blob([s2ab(res.data)], {
      type: "application/octet-stream",
    });
    saveAs(excelBlob, "InventorySample.xlsx");
  } else {
    const csvBlob = new Blob([s2ab(res.data)], {
      type: "text/csv;charset=utf-8",
    });
    saveAs(csvBlob, "InventorySample.csv");
  }
}

export function s2ab(s) {
  var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
  var view = new Uint8Array(buf); //create uint8array as viewer
  for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff; //convert to octet
  return buf;
}

export const getDashboard = (key) => {
  let dashboard = localStorage.getItem("dashboard");
  if (dashboard) {
    return JSON.parse(dashboard)?.[key];
  }
  return "-";
};

export const ActionTypesFactory = (prefix, type) => {
  let p = _.upperCase(prefix) + "/" + _.upperCase(type);
  return {
    REQUEST: p + "_REQUEST",
    INPROGRESS: p + "_INPROGRESS",
    SUCCESS: p + "_SUCCESS",
    FAILED: p + "_FAILED",
    CHANGED: p + "_CHANGED",
    RESET: p + "_RESET",
    custom: (name) => {
      return `${p}_${name}`;
    },
  };
};

export const sagaFunctions = (
  action_type,
  method,
  api,
  data,
  headers,
  saveFile
) => {
  return function* () {
    let res = null;
    let responseType = "binary";
    try {
      if (method === "post" || method === "put") {
        res = yield call(endpoint[method], api, data, {
          headers,
        });
      } else {
        let filters = data.filters;
        if (filters) {
          delete data.filters;
        }
        res = yield call(endpoint[method], api, {
          headers,
          params: data,
          body: filters,
          responseType: saveFile ? responseType : undefined,
        });
      }
      if (saveFile) {
        exportToFile({ res });
        yield put({
          type: action_type.SUCCESS,
          payload: res.data,
        });
        return;
      }
      if (res.status < 400) {
        console.log("success action");
        yield put({
          type: action_type.SUCCESS,
          payload: res.data,
        });
      } else {
        yield put({
          type: action_type.FAILED,
          payload: res.data,
        });
      }
    } catch (err) {
      console.log(err);
      yield put({
        type: action_type.FAILED,
        payload: err?.response?.data,
      });
    }
  };
};

export const ReducerFunctions = (ActionType, initialState) => {
  return function (state = initialState, action) {
    let data = Array.isArray(action?.payload)
      ? [...action?.payload]
      : typeof action?.payload === "string"
        ? action?.payload
        : { ...action?.payload };
    switch (action?.type) {
      case ActionType.REQUEST:
        return {
          ...state,
          loading: true,
        };
      case ActionType.SUCCESS: {
        return {
          ...state,
          data,
          loading: false,
          success: true,
        };
      }
      case ActionType.FAILED:
        return {
          ...state,
          data,
          loading: false,
          success: false,
        };
      case ActionType.RESET:
        return {
          loading: false,
        };

      default:
        return state;
    }
  };
};

let idleTimeout;
export const startIdleTimer = (onTimeout) => {
  const resetTimer = () => {
    clearTimeout(idleTimeout);
    idleTimeout = setTimeout(onTimeout, 60 * 60 * 1000); // 1 hour
  };

  window.onload = resetTimer;
  document.onmousemove = resetTimer;
  document.onkeypress = resetTimer;
  document.onclick = resetTimer;
  document.onscroll = resetTimer;
};
